import { useSelector } from 'react-redux'

import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'
import { getAiCoachPromoState } from '@lyrahealth-inc/shared-app-logic/src/features/messaging/utils'
import { Episode } from '@lyrahealth-inc/shared-app-logic/src/models/episodes/Episodes'
import { MessageConversation } from '@lyrahealth-inc/shared-app-logic/src/models/messages/Messages'

import { getGenAiOptOut } from '../../data/customer/customerSelectors'
import { getAICoachConversations, getEpisodes } from '../../data/lyraTherapy/lyraTherapySelectors'

/**
 * Hook that determines if AI Coach is available based on:
 * - AI Coach conversations exist
 * - Customer has not opted out of genAI
 * - AI Coach feature flag is enabled
 */
export const useShouldShowAICoach = (): { showAiCoach: boolean; aiCoachPromoEnabledProviderIds: string[] } => {
  const { isAiCoachEnabled } = useFlags()
  const genAiOptOut = useSelector(getGenAiOptOut)
  const aiCoachConversations: MessageConversation[] = useSelector(getAICoachConversations)?.toJS() ?? []
  const episodes: Episode[] = useSelector(getEpisodes)?.toJS() ?? []
  return getAiCoachPromoState({
    conversations: aiCoachConversations,
    genAiOptOut,
    isAiCoachEnabled,
    episodes,
  })
}
